import { Translation } from 'src/types/Translation';
import { useTranslations } from '../hooks/useTranslations';

export const useFieldTranslation = () => {
  const siteInformationFields = useTranslations({} as Translation, { returnObjects: true }, 'siteInformationFields');
  const otherFields = useTranslations({} as Translation, { returnObjects: true }, 'otherFields');
  const sitePersonnelFields = useTranslations({} as Translation, { returnObjects: true }, 'sitePersonnelFields');
  const saveTxt = useTranslations({} as Translation, {}, 'save');
  const cancelTxt = useTranslations({} as Translation, {}, 'cancel');
  const nextTxt = useTranslations({} as Translation, {}, 'next');
  const acceptNext = useTranslations({} as Translation, {}, 'acceptNext');
  const noChangeMsg = useTranslations({} as Translation, {}, 'nochangemsg');
  const addPersonnel = useTranslations({} as Translation, {}, 'addPersonnel');
  const accessRequested = useTranslations({} as Translation, {}, 'accessRequested');
  const requestAccess = useTranslations({} as Translation, {}, 'requestAccess');
  const siteInformationHelpText = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'siteInformationHelpText'
  );
  const personnelHelpText = useTranslations({} as Translation, { returnObjects: true }, 'personnelHelpText');
  const raiseQueryHelpText = useTranslations({} as Translation, { returnObjects: true }, 'raiseQueryHelpText');
  const deleteQueryHelpText = useTranslations({} as Translation, { returnObjects: true }, 'deleteQueryHelpText');
  const createQueryResHelpText = useTranslations({} as Translation, { returnObjects: true }, 'createQueryResHelpText');
  const queriesHelpText = useTranslations({} as Translation, { returnObjects: true }, 'queriesHelpText');
  const mileStoneTrackingHelpText = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'mileStoneTrackingHelpText'
  );
  const siteContactInfoHelpText = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'siteContactInfoHelpText'
  );
  const startupPacketHelpText = useTranslations({} as Translation, { returnObjects: true }, 'startupPacketHelpText');
  const documentUploadHelpText = useTranslations({} as Translation, { returnObjects: true }, 'documentUploadHelpText');
  const sqChecklistHelpText = useTranslations({} as Translation, { returnObjects: true }, 'SQChecklistHelpText');
  const sqReportHelpText = useTranslations({} as Translation, { returnObjects: true }, 'SQReportHelpText');
  const siteDocumentsPageHelpText = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'siteDocumentsPageHelpText'
  );
  const ipManagementPageHelpText = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'IpManagementPageHelpText'
  );
  const sivChecklistHelpText = useTranslations({} as Translation, { returnObjects: true }, 'sivChecklistHelpText');
  const sivReportHelpText = useTranslations({} as Translation, { returnObjects: true }, 'sivReportHelpText');
  const studyInformation = useTranslations({} as Translation, { returnObjects: true }, 'studyInformation');

  const feasibilityAssessmentFields = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'feasibilityAssessmentFields'
  );
  const contractAndBuget = useTranslations({} as Translation, { returnObjects: true }, 'contractAndBuget');
  const qualificationChecklist = useTranslations({} as Translation, { returnObjects: true }, 'qualificationChecklist');
  const priorToTheVisit = useTranslations({} as Translation, { returnObjects: true }, 'priorToTheVisit');
  const supportingDocumentation = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'supportingDocumentation'
  );
  const duringTheSiteQualificationVisit = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'duringTheSiteQualificationVisit'
  );
  const afterTheSiteQualificationVisit = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'afterTheSiteQualificationVisit'
  );
  const qualificationReport = useTranslations({} as Translation, { returnObjects: true }, 'qualificationReport');
  const ipSupplyOrder = useTranslations({} as Translation, { returnObjects: true }, 'ipSupplyOrder');
  const checklistClinicalTrailDetails = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'checklistClinicalTrailDetails'
  );
  const checklistSiteAdequacy = useTranslations({} as Translation, { returnObjects: true }, 'checklistSiteAdequacy');
  const checklistInformedConsent = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'checklistInformedConsent'
  );
  const checklistAdverseEventReporting = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'checklistAdverseEventReporting'
  );
  const unSavedWarning = useTranslations({} as Translation, { returnObjects: true }, 'unSavedWarning');
  const checklistReqForECRFCompletion = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'checklistReqForECRFCompletion'
  );
  const checklistSourceDocumentation = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'checklistSourceDocumentation'
  );
  const checklistMonitoring = useTranslations({} as Translation, { returnObjects: true }, 'checklistMonitoring');
  const checklistConfirm = useTranslations({} as Translation, { returnObjects: true }, 'checklistConfirm');
  const reportClinicalTrailDetails = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'reportClinicalTrailDetails'
  );
  const reportSiteAdequacy = useTranslations({} as Translation, { returnObjects: true }, 'reportSiteAdequacy');
  const reportInformedConsent = useTranslations({} as Translation, { returnObjects: true }, 'reportInformedConsent');
  const reportAdverseEventReporting = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'reportAdverseEventReporting'
  );
  const reportReqForECRFCompletion = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'reportReqForECRFCompletion'
  );
  const reportSourceDocumentation = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'reportSourceDocumentation'
  );
  const reportMonitoring = useTranslations({} as Translation, { returnObjects: true }, 'reportMonitoring');
  const reportConfirm = useTranslations({} as Translation, { returnObjects: true }, 'reportConfirm');
  const studyLogs = useTranslations({} as Translation, { returnObjects: true }, 'studyLogs');
  const DOA = useTranslations({} as Translation, { returnObjects: true }, 'DOA');
  const trainingLog = useTranslations({} as Translation, { returnObjects: true }, 'trainingLog');
  const form1572 = useTranslations({} as Translation, { returnObjects: true }, 'form1572');
  const drugAccountabilityRecord = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'drugAccountabilityRecord'
  );
  const overView = useTranslations({} as Translation, { returnObjects: true }, 'overView');
  const received = useTranslations({} as Translation, { returnObjects: true }, 'received');
  const despensation = useTranslations({} as Translation, { returnObjects: true }, 'despensation');
  const darReturn = useTranslations({} as Translation, { returnObjects: true }, 'DARreturn');
  const distruction = useTranslations({} as Translation, { returnObjects: true }, 'distruction');
  const transfer = useTranslations({} as Translation, { returnObjects: true }, 'transfer');
  const quarantine = useTranslations({} as Translation, { returnObjects: true }, 'Quarantine');
  const siteDocuments = useTranslations({} as Translation, { returnObjects: true }, 'siteDocuments');
  const ipRelease = useTranslations({} as Translation, { returnObjects: true }, 'ipRelease');
  const conductStudyLogs = useTranslations({} as Translation, { returnObjects: true }, 'conductStudyLogs');
  const issueLogs = useTranslations({} as Translation, { returnObjects: true }, 'issueLogs');

  const applicationModuleSection = useTranslations(
    {} as Translation,
    { returnObjects: true },
    'applicationModuleSection'
  );
  return {
    siteInformationFields: siteInformationFields.siteInformationFields,
    sitePersonnelFields: sitePersonnelFields.sitePersonnelFields,
    otherFields: otherFields.otherFields,
    saveTxt: saveTxt.save,
    cancelTxt: cancelTxt.cancel,
    nextTxt: nextTxt.next,
    acceptNext: acceptNext.acceptNext,
    noChangeMsg: noChangeMsg.nochangemsg,
    addPersonnel: addPersonnel.addPersonnel,
    accessRequested: accessRequested.accessRequested,
    requestAccess: requestAccess.requestAccess,
    siteInformationUpdateSuccessMsg: siteInformationHelpText.siteInformationHelpText.updateSuccessMsg,
    siteInformationUpdateErrorMsg: siteInformationHelpText.siteInformationHelpText.updateErrorMsg,
    personnelHelpText: personnelHelpText.personnelHelpText,
    raiseQuerySuccessMsg: raiseQueryHelpText.raiseQueryHelpText.successMsg,
    raiseQueryErrorMsg: raiseQueryHelpText.raiseQueryHelpText.errorMsg,
    deleteQuerySuccessMsg: deleteQueryHelpText.deleteQueryHelpText.successMsg,
    deleteQueryErrorMsg: deleteQueryHelpText.deleteQueryHelpText.errorMsg,
    createQueryResSuccessMsg: createQueryResHelpText.createQueryResHelpText.successMsg,
    createQueryResErrorMsg: createQueryResHelpText.createQueryResHelpText.errorMsg,
    fieldQuery: queriesHelpText.queriesHelpText.field,
    sectionQuery: queriesHelpText.queriesHelpText.section,
    raiseFieldQuery: queriesHelpText.queriesHelpText.raiseFieldQuery,
    raiseSectionQuery: queriesHelpText.queriesHelpText.raiseSectionQuery,
    viewFieldQuery: queriesHelpText.queriesHelpText.viewFieldQuery,
    viewAllQueries: queriesHelpText.queriesHelpText.viewAllQuery,
    mileStoneErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.errorMsg,
    mileStoneDataUpdatedMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.dataUpdatedMsg,
    mileStoneLoadingErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.loadingErrorMsg,
    mileStoneInvalidDateErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.invalidDateErrorMsg,
    mileStoneActualStartDateErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.ActualStartDateErrorMsg,
    mileStoneActualEndDateErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.ActualEndDateErrorMsg,
    mileStoneStartDateErrorMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.StartDateErrorMsg,
    mileStoneStatusChangeMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.statusChangeMsg,
    mileStoneNostatusChangeMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.nostatusChangeMsg,
    mileStoneErrorstatusChangeMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.errorstatusChangeMsg,
    mileStoneDateUpdateValidationMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.dateUpdateValidationMsg,
    mileStoneInvalidDateValidationMsg: mileStoneTrackingHelpText.mileStoneTrackingHelpText.invalideDatesInAudit,
    mileStoneTrackingHelpText: mileStoneTrackingHelpText.mileStoneTrackingHelpText,
    sciDataUpdatedSuccessMsg: siteContactInfoHelpText.siteContactInfoHelpText.dataUpdatedSuccessMsg,
    sciRequestSendSuccessMsg: siteContactInfoHelpText.siteContactInfoHelpText.requestSendSuccessMsg,
    sciSitePersonalAddSuccessMsg: siteContactInfoHelpText.siteContactInfoHelpText.sitePersonalAddSuccessMsg,
    sciErrorMsg: siteContactInfoHelpText.siteContactInfoHelpText.errorMsg,
    sciRequiredMsg: siteContactInfoHelpText.siteContactInfoHelpText.requiredMsg,
    spDataUpdateSuccessMsg: startupPacketHelpText.startupPacketHelpText.dataUpdateSuccessMsg,
    spErrorMsg: startupPacketHelpText.startupPacketHelpText.errorMsg,
    spMendatoryInfoErrorMsg: startupPacketHelpText.startupPacketHelpText.mendatoryInfoErrorMsg,
    duFileUploadErrorMsg: documentUploadHelpText.documentUploadHelpText.fileUploadErrorMsg,
    duDocumentUploadSuccessMsg: documentUploadHelpText.documentUploadHelpText.documentUploadSuccessMsg,
    sqcDataUpdateSuccessMsg: sqChecklistHelpText.SQChecklistHelpText.dataUpdateSuccessMsg,
    sqcSitePersonalAddErrorMsg: sqChecklistHelpText.SQChecklistHelpText.SitePersonalAddErrorMsg,
    sqcMendatoryInfoErrorMsg: sqChecklistHelpText.SQChecklistHelpText.mendatoryInfoErrorMsg,
    sqrDataUpdateSuccessMsg: sqReportHelpText.SQReportHelpText.dataUpdateSuccessMsg,
    sqrErrorMsg: sqReportHelpText.SQReportHelpText.errorMsg,
    sqrMendatoryInfoErrorMsg: sqReportHelpText.SQReportHelpText.mendatoryInfoErrorMsg,
    sqrPresentDoumentErrorMsg: sqReportHelpText.SQReportHelpText.presentDoumentErrorMsg,
    sqrFileUploadErrorMsg: sqReportHelpText.SQReportHelpText.fileUploadErrorMsg,
    sqrFileDeleteSuccessMsg: sqReportHelpText.SQReportHelpText.fileDeleteSuccessMsg,
    sqrLoadingErrorMsg: sqReportHelpText.SQReportHelpText.loadingErrorMsg,
    sdpDataUpdateSuccessMsg: siteDocumentsPageHelpText.siteDocumentsPageHelpText.dataUpdateSuccessMsg,
    sdpErrorMsg: siteDocumentsPageHelpText.siteDocumentsPageHelpText.errorMsg,
    ipmMendatoryInfoErrorMsg: ipManagementPageHelpText.IpManagementPageHelpText.mendatoryInfoErrorMsg,
    ipmFileuploadErrorMsg: ipManagementPageHelpText.IpManagementPageHelpText.fileuploadErrorMsg,
    ipmFileAddSuccessMsg: ipManagementPageHelpText.IpManagementPageHelpText.fileAddSuccessMsg,
    ipmDataUpdateSuccessMsg: ipManagementPageHelpText.IpManagementPageHelpText.dataUpdateSuccessMsg,
    ipmErrorMsg: ipManagementPageHelpText.IpManagementPageHelpText.errorMsg,
    ipmConformationMsg: ipManagementPageHelpText.IpManagementPageHelpText.conformationMsg,
    ipmInvalidDateErrorMsg: ipManagementPageHelpText.IpManagementPageHelpText.invalidDateErrorMsg,
    sivcSaveModifiedMsg: sivChecklistHelpText.sivChecklistHelpText.saveModifiedMsg,
    sivcErrorMsg: sivChecklistHelpText.sivChecklistHelpText.errorMsg,
    sivcDataUpdateSuccessMsg: sivChecklistHelpText.sivChecklistHelpText.dataUpdateSuccessMsg,
    sivcMendatoryInfoErrorMsg: sivChecklistHelpText.sivChecklistHelpText.mendatoryInfoErrorMsg,
    sivrDataUpdateSuccessMsg: sivReportHelpText.sivReportHelpText.dataUpdateSuccessMsg,
    sivrSubmitsuccessMsg: sivReportHelpText.sivReportHelpText.submitsuccessMsg,
    sivrErrorMsg: sivReportHelpText.sivReportHelpText.errorMsg,
    sivrMendatoryInfoErrorMsg: sivReportHelpText.sivReportHelpText.mendatoryInfoErrorMsg,
    sivrSaveModifiedMsg: sivReportHelpText.sivReportHelpText.saveModifiedMsg,
    sivrInvalidDate: sivReportHelpText.sivReportHelpText.invalidDate,
    studyInformation: studyInformation.studyInformation,
    feasibilityAssessmentFields: feasibilityAssessmentFields.feasibilityAssessmentFields,
    contractAndBuget: contractAndBuget.contractAndBuget,
    qualificationChecklist: qualificationChecklist.qualificationChecklist,
    priorToTheVisit: priorToTheVisit.priorToTheVisit,
    supportingDocumentation: supportingDocumentation.supportingDocumentation,
    duringTheSiteQualificationVisit: duringTheSiteQualificationVisit.duringTheSiteQualificationVisit,
    afterTheSiteQualificationVisit: afterTheSiteQualificationVisit.afterTheSiteQualificationVisit,
    qualificationReport: qualificationReport.qualificationReport,
    ipSupplyOrder: ipSupplyOrder.ipSupplyOrder,
    checklistClinicalTrailDetails: checklistClinicalTrailDetails.checklistClinicalTrailDetails,
    checklistSiteAdequacy: checklistSiteAdequacy.checklistSiteAdequacy,
    checklistInformedConsent: checklistInformedConsent.checklistInformedConsent,
    checklistAdverseEventReporting: checklistAdverseEventReporting.checklistAdverseEventReporting,
    checklistReqForECRFCompletion: checklistReqForECRFCompletion.checklistReqForECRFCompletion,
    checklistSourceDocumentation: checklistSourceDocumentation.checklistSourceDocumentation,
    checklistMonitoring: checklistMonitoring.checklistMonitoring,
    checklistConfirm: checklistConfirm.checklistConfirm,
    reportClinicalTrailDetails: reportClinicalTrailDetails.reportClinicalTrailDetails,
    reportSiteAdequacy: reportSiteAdequacy.reportSiteAdequacy,
    reportInformedConsent: reportInformedConsent.reportInformedConsent,
    reportAdverseEventReporting: reportAdverseEventReporting.reportAdverseEventReporting,
    reportReqForECRFCompletion: reportReqForECRFCompletion.reportReqForECRFCompletion,
    reportSourceDocumentation: reportSourceDocumentation.reportSourceDocumentation,
    reportMonitoring: reportMonitoring.reportMonitoring,
    reportConfirm: reportConfirm.reportConfirm,
    studyLogs: studyLogs.studyLogs,
    DOA: DOA.DOA,
    trainingLog: trainingLog.trainingLog,
    form1572: form1572.form1572,
    drugAccountabilityRecord: drugAccountabilityRecord.drugAccountabilityRecord,
    overView: overView.overView,
    received: received.received,
    despensation: despensation.despensation,
    DARreturn: darReturn.DARreturn,
    distruction: distruction.distruction,
    transfer: transfer.transfer,
    Quarantine: quarantine.Quarantine,
    siteDocuments: siteDocuments.siteDocuments,
    ipRelease: ipRelease.ipRelease,
    unSavedWarning: unSavedWarning.unSavedWarning,
    applicationModuleSection: applicationModuleSection.applicationModuleSection,
    issueLogs: issueLogs.issueLogs,
    conductStudyLogs: conductStudyLogs.conductStudyLogs
  };
};
